module.exports = __webpack_public_path__ + "img/capt_a.403af5f8.jpeg";